import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { clearOfficeSearch, setCurrentOffice } from '@redux/modules/office';
import { getAuditLog } from '@redux/modules/audit';
import { selectSearchResults } from '@redux/selectors/OfficeSelector';
import { loadFormDefinition } from '@redux/modules/formGeneration';

import Swal from 'sweetalert2/src/sweetalert2';
import Panel from '@components/smartAdminUI/Panel';
import Button from '@components/smartAdminUI/Button';
import OfficeAdvancedSearch from '@components/office/OfficeAdvancedSearch';
import OfficesTable from '@components/table/OfficesTable';
import { isNull } from 'lodash';

const SearchOfficePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchResults = useSelector(selectSearchResults);
  // clears Office Redux state on unmount
  useEffect(() => () => dispatch(clearOfficeSearch()), []);

  const officeSelected = row => {
    dispatch(setCurrentOffice(row.UniqueID));
  };

  const auditClicked = row => {
    Swal.fire({
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      position: 'center',
      html: 'Loading Office Audit Log...',
      title: '<span class="fa-stack fa-2x text-secondary m-3"><i class="fal fa-circle-notch fa-spin fa-stack-2x"></i><i class="fas fa-history fa-stack-1x"></i></span>',
      showConfirmButton: false,
      timer: 2000,
    });
    dispatch(getAuditLog({ tableName: 'Office', uniqueID: row.UniqueID, entityID: row.OfficeMlsId }));
    history.push('/audit');
  };

  return (
    <>
      <div className="subheader">
        <h1 className="subheader-title">
          <i className="subheader-icon fal fa-search mr-2" />
          Search
          <span className="fw-300 ml-2 mr-2">Offices</span>
        </h1>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <Panel
            header="Search Criteria"
            customClass="searchCriteria"
            panelToolbar={(
              <Button name="btnCreateOffice" variant="primary btn-sm" onClick={() => dispatch(loadFormDefinition('create', 'office', null, null, 'officeACL'))}>
                <i className="fas fa-plus mr-2" aria-hidden="true" />
                Create Office
              </Button>
            )}
          >
            <OfficeAdvancedSearch />
          </Panel>
        </div>
        {!isNull(searchResults) && (
          <div className="col-xl-12">
            <Panel header="Search Results" customClass="searchResults">
              <OfficesTable
                displayData={searchResults}
                onOfficeSelect={officeSelected}
                onAuditClick={auditClicked}
              />
            </Panel>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchOfficePage;
